var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.screenWidth < 1000)?_c('downloadPopup'):_vm._e(),_c('router-view',{staticStyle:{"overflow-y":"scroll"}}),_c('footerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }